/**
 * Template for the sign up pages
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import SignUpProgress from './SignUpProgress/SignUpProgress';

const propTypes = {
  classes: PropTypes.shape({
    progress: PropTypes.string.isRequired,
    root: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  subheader: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  primaryEmail: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  activeStep: PropTypes.number,
  email: PropTypes.bool.isRequired,
  migrated: PropTypes.bool.isRequired,
};

const defaultProps = {
  children: null,
  activeStep: 0,
  subheader: null,
};

export function UnstyledSignUpTemplate({
  classes,
  header,
  subheader,
  children,
  activeStep,
  migrated,
  primaryEmail,
  email,
}) {
  const progress =
    typeof activeStep === 'number' ? (
      <SignUpProgress className={classes.progress} activeStepIndex={activeStep} />
    ) : null;
  const migrationMessage = migrated ? (
    <React.Fragment>
      <Typography variant="h4" color="primary" align="center" className={classes.title}>
        Welcome to Mission Control!
      </Typography>
      <Typography className={classes.migration} variant="body2" align="center">
        You have been successfully migrated to our new platform. Please enter your Organization info
        below. Once you’re in you’ll find your existing MongoDB, Redis or ElasticSearch Instances.
      </Typography>
    </React.Fragment>
  ) : null;
  const emailSection = email ? (
    <Typography variant="body2" color="primary" align="center" className={classes.email}>
      {primaryEmail}
    </Typography>
  ) : null;
  const subheaderSection = subheader ? (
    <Typography variant="body2" align="center">
      {subheader}
    </Typography>
  ) : null;
  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={0}
        justify="center"
        className={classes.content}
        alignContent="flex-start"
      >
        <Grid item lg={4} md={3} sm={2} xs={false} />
        <Grid item lg={4} md={6} sm={8} xs={12}>
          <img
            src="../images/logos/or-logo-white-sans.svg"
            className={classes.logo}
            alt="ObjectRocket logo"
          />
          {progress}
          {migrationMessage}
          <Typography variant="h4" color="primary" align="center" className={classes.title}>
            {header}
          </Typography>
          {emailSection}
          {subheaderSection}
        </Grid>
        <Grid item lg={4} md={3} sm={2} xs={false} />
        <Grid item lg={4} md={6} sm={8} xs={12}>
          {children}
        </Grid>
      </Grid>
    </div>
  );
}

UnstyledSignUpTemplate.propTypes = propTypes;
UnstyledSignUpTemplate.defaultProps = defaultProps;

const styles = (theme) => ({
  root: {
    textAlign: 'center',

    [theme.breakpoints.down('lg')]: {
      padding: '.5rem',
    },
  },
  logo: {
    paddingTop: '4rem',
    maxWidth: 330,
    width: '100%',
    height: 'auto',

    [theme.breakpoints.down('lg')]: {
      padding: '2rem 0',
    },
  },
  progress: {
    paddingTop: '3rem',

    [theme.breakpoints.down('lg')]: {
      padding: '0 0',
    },
  },
  migration: {
    fontStyle: 'italic',
  },
  title: {
    paddingTop: '2rem',
  },
  email: {
    lineHeight: '3rem',
    fontSize: theme.typography.h6.fontSize,
  },
});

export default withStyles(styles)(UnstyledSignUpTemplate);
